import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEMiningCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Mining Engineering",
    shortName: "B.E. Mining",
    duration: "4 years",
    description: "Engineering program focused on extraction of minerals and resources from the earth through safe and efficient mining operations",
    overview: "Bachelor of Engineering in Mining Engineering (B.E. Mining) is a 4-year undergraduate program that deals with the extraction of minerals, coal, and other valuable materials from the earth. This course covers mining methods, rock mechanics, mine planning, safety systems, and environmental protection, preparing students for careers in mining companies, government organizations, and consulting firms.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in geology and mining operations"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Introduction to Mining Engineering",
          "Earth Sciences and Geology"
        ]
      },
      {
        year: 2,
        subjects: [
          "Rock Mechanics",
          "Mining Geology",
          "Surveying and Mine Surveying",
          "Strength of Materials",
          "Fluid Mechanics",
          "Mineral Processing"
        ]
      },
      {
        year: 3,
        subjects: [
          "Surface Mining Methods",
          "Underground Mining Methods",
          "Mine Planning and Design",
          "Explosives and Blasting",
          "Mine Ventilation",
          "Mining Machinery"
        ]
      },
      {
        year: 4,
        subjects: [
          "Mine Safety and Environment",
          "Coal Preparation and Utilization",
          "Mine Economics and Valuation",
          "Remote Sensing and GIS",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Mining Engineer",
        "Mine Planner",
        "Safety Engineer",
        "Exploration Geologist",
        "Environmental Engineer",
        "Mine Surveyor",
        "Project Manager",
        "Mining Consultant",
        "Research Scientist",
        "Government Mining Officer"
      ],
      industries: [
        "Coal Mining Companies",
        "Iron Ore Mining",
        "Limestone and Cement",
        "Precious Metals Mining",
        "Quarrying and Stone Mining",
        "Government Mining Departments",
        "Environmental Consulting",
        "Mining Equipment Manufacturing",
        "Geological Survey Organizations",
        "Research Institutions"
      ],
      averageSalary: "₹6-12 LPA (Fresher), ₹18-45 LPA (Experienced)",
      topRecruiters: [
        "Coal India Limited (CIL)",
        "NMDC, SAIL, Hindalco",
        "Tata Steel, JSW Steel",
        "Adani Mining, Vedanta",
        "ACC, UltraTech Cement",
        "Geological Survey of India"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Indian Institute of Technology (ISM) Dhanbad",
        location: "Jharkhand",
        fees: "₹8,00,000",
        ranking: "NIRF Ranking: 16"
      },
      {
        name: "National Institute of Technology Rourkela",
        location: "Odisha",
        fees: "₹5,40,000",
        ranking: "NIRF Ranking: 16"
      },
      {
        name: "Birla Institute of Technology Mesra",
        location: "Jharkhand",
        fees: "₹13,00,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Anna University (CEG)",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      }
    ],

    skills: [
      "Mine Planning Software",
      "AutoCAD and Mine Modeling",
      "Rock Mechanics Analysis",
      "GIS and Remote Sensing",
      "MATLAB/Surpac",
      "Blasting Design",
      "Environmental Impact Assessment",
      "Safety Management Systems",
      "Project Management",
      "Equipment Selection"
    ],

    futureScope: "Good prospects with India's infrastructure development, growing mineral demands, sustainable mining practices, and automation in mining operations creating opportunities.",

    faqs: [
      {
        question: "Is Mining Engineering safe as a career?",
        answer: "Modern mining emphasizes safety heavily with advanced technology, automation, and strict safety protocols. Most mining engineers work in planning, design, and management roles."
      },
      {
        question: "Are there opportunities outside traditional mining?",
        answer: "Yes, mining engineers work in environmental consulting, construction, tunneling, geotechnical engineering, and government regulatory roles."
      },
      {
        question: "What about government job opportunities?",
        answer: "Excellent opportunities in Coal India Limited, NMDC, Geological Survey of India, and various state mining departments through competitive exams."
      },
      {
        question: "Is the field moving towards automation?",
        answer: "Yes, modern mining increasingly uses automation, drones, and AI. This creates opportunities for tech-savvy mining engineers in advanced mining operations."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEMiningCoursePage;
